exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.spacer-subsection[data-v-e1a9a2d8] {\n  margin-top: 64px;\n}\n.spacer-subsection-smaller[data-v-e1a9a2d8] {\n  margin-top: 33px;\n}\n.channels[data-v-e1a9a2d8] {\n  padding: 10px;\n  margin: 10px;\n}\n.channel[data-v-e1a9a2d8] {\n  margin: 10px;\n  padding: 10px;\n}\n.channel-category-label[data-v-e1a9a2d8] {\n  font-size: 16px;\n  line-height: 19px;\n  color: #353635;\n  font-weight: bold;\n  margin-bottom: 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e1a9a2d8","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/channels/ChannelList.vue
// module id = mfcA
// module chunks = 53